import { Link } from "react-router-dom"
import React from "react"

export default function MajorCatCard(props) {
  const imageUrl = require(`../../../assets/category/small/${props.catIcon}`);
  return (
    <div className="major-cat-card">
      <Link to={props.catLink}>
        <div className="company-card-container">
          <img
            src={imageUrl}
            alt="product category image"
          />
        </div>
        <code>{props.catName}</code>
      </Link>
    </div>
  )
}
